export default "__VITE_ASSET__de26c815__"